export default __webpack_public_path__ + "static/media/58.47328ff6.jpg";